export default __webpack_public_path__ + "static/img18-d16285359fd80134740fef110ac4f867.png";